import useCurrentLoginUserInfo from '@/hooks/useCurrentLoginUserInfo';
import { useMenuConfig } from '@/hooks/useMenu';
import useMenuPer from '@/hooks/useMenuPermission/indx';
import usePermission from '@/hooks/usePermission';
import useThemeToken from '@/hooks/useTheme';
import { useLocales } from '@/Locales';
import UserInfo from '@/pages/home/components/UserInfo';
import { getDomain } from '@/services/common';
import { useCacheTab } from '@/store/cacheTab';
import { getLocalStorage, TOKEN_KEY } from '@/utils/cookies';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import { Button, Divider, Dropdown, Layout, Menu, Spin } from '@sinohealth/butterfly-ui-components';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useAliveController } from 'react-activation';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from './components/Breadcrumb';
import CacheBar from './components/CacheBar';
import FontSize from './components/FontSize';
import Team from './components/Team';
import styles from './index.less';

// const logoImg = require('@/assets/images/common/imdt_logo.svg');

const { Header, Sider, Content } = Layout;

const Home: React.FC = () => {
  const themeToken = useThemeToken();
  const [userInfo] = useCurrentLoginUserInfo();
  const location = useLocation(); // 获取当前路由
  const { refresh } = useAliveController();
  const pathname = location.pathname;
  const per = useMenuPer();
  const [collapsed, setCollapsed] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const navigate = useNavigate();
  const { menuData, defaultOpenKeys, defaultSelectedKeys } = useMenuConfig();
  const permission = usePermission('commonLayout');
  const { locales, changeLocales, t } = useLocales();
  const { cacheHeight, setCacheHeight } = useCacheTab();
  const [caseSimulatorUrl, setCaseSimulatorUrl] = useState<string>('');
  const [breadCrumbHeight, setBreadCrumbHeight] = useState(47); // 面包屑高度

  const fullPage = () => {
    setFullscreen(!fullscreen);
    if (fullscreen) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };

  useEffect(() => {
    if (userInfo?.user?.id) getCaseSimulatorUrl();
  }, [userInfo]);

  useEffect(() => {
    setBreadCrumbHeight(pathname === '/index' ? 0 : breadCrumbHeight);
  }, [pathname]);

  const getCaseSimulatorUrl = async () => {
    const hostUrl = await getDomain();
    const token = getLocalStorage(TOKEN_KEY);
    const redirect = encodeURIComponent('/');
    const userId = userInfo?.user?.id;
    const url = `${hostUrl}/#/quick-login/?token=${token}&userId=${userId}&redirect=${redirect}`;
    setCaseSimulatorUrl(url);
  };

  const handleMenuClick = (e: any) => {
    // 查找点击的菜单项
    const findMenuItem = (items: any[], key: string): any => {
      let result = null;
      items.some((item) => {
        if (item.key === key) {
          result = item;
          return true;
        }
        if (item.children) {
          const found = findMenuItem(item.children, key);
          if (found) {
            result = found;
            return true;
          }
        }
        return false;
      });
      return result;
    };

    const menuItem = findMenuItem(menuData, e.key);

    // 如果是外链，新窗口打开
    if (menuItem?.['data-is-external']) {
      window.open(menuItem.key, menuItem['data-target'] || '_blank');
    } else {
      // 内部路由跳转
      navigate(e.key);
    }
  };

  // useEffect(() => {
  //   if (userInfo) {
  //     const roleCodes = userInfo?.roleCodes || [];
  //     const closeUrl = ['/index', '/index/patient-detail'];
  //     if (roleCodes?.includes('doctor') && closeUrl.includes(pathname)) {
  //       setCollapsed(true);
  //     } else {
  //       setCollapsed(false);
  //     }
  //   }
  // }, [userInfo, pathname]);

  if (!userInfo) {
    return (
      <div style={{ display: 'flex', height: '100vh' }}>
        <Spin size="large" style={{ margin: 'auto' }} />
      </div>
    );
  }

  const localesItems = [
    {
      key: 'zh-cn',
      label: '中文',
      onClick: () => changeLocales('zh-cn'),
    },
    {
      key: 'en',
      label: 'English',
      onClick: () => changeLocales('en'),
    },
  ];

  const renderHeader = () => {
    return (
      <Header
        className={styles.header}
        style={{
          backgroundColor: themeToken.colorBgContainer,
          borderColor: themeToken.colorBorder,
        }}
      >
        <div className={styles.logo}>
          {/* <img className={styles.logoImg} src={logoImg} alt="logo" /> */}
          <div className={styles.logoImg} />
          <Divider type="vertical" orientationMargin={16} />
          <div
            className={styles.name}
            style={{
              fontSize: locales === 'zh-cn' ? '20px' : '16px',
              color: themeToken.colorText,
            }}
          >
            {t('管理平台')}
          </div>
        </div>
        {/* <div className={styles.pageInfo}>
          <Button
            className={styles.collapsedBtn}
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
          <Navbar />
        </div> */}
        <div className={styles.toolbar}>
          {/* <a onClick={changeLocales}> */}
          {/*  {locales === 'zh-cn' ? '中文' : 'English'} */}
          {/* </a> */}
          <FontSize />
          <Team />
          <Dropdown menu={{ items: localesItems }}>
            <Button
              type="text"
              icon={
                <span style={{ color: themeToken.colorText }} className="iconfont icon-translate" />
              }
            />
            {/* <span style={{ cursor: 'pointer' }}>
                {t('语言')}&nbsp;
                <CaretDownOutlined
                  style={{ color: 'rgba(11, 33, 69, 0.65)', pointerEvents: 'none' }}
                />
              </span> */}
          </Dropdown>
          <Button
            className={styles.fullBtn}
            type="text"
            icon={
              !fullscreen ? (
                <FullscreenOutlined
                  style={{
                    color: themeToken.colorTextTertiary,
                    borderRadius: 2,
                    border: `1px solid ${themeToken.colorTextTertiary}`,
                  }}
                />
              ) : (
                <FullscreenExitOutlined
                  style={{
                    color: themeToken.colorTextTertiary,
                    borderRadius: 2,
                    border: `1px solid ${themeToken.colorTextTertiary}`,
                  }}
                />
              )
            }
            onClick={() => fullPage()}
          />
          <UserInfo />
        </div>
      </Header>
    );
  };

  const renderSider = () => {
    return (
      <Sider
        className={styles.sider}
        style={{
          backgroundColor: themeToken.colorBgContainer,
          borderColor: themeToken.colorBorder,
        }}
        theme="light"
        trigger={null}
        collapsible
        width={228}
        collapsed={collapsed}
      >
        <Menu
          onClick={handleMenuClick}
          style={{
            backgroundColor: themeToken.colorBgContainer,
          }}
          key={defaultSelectedKeys[0] + defaultOpenKeys[0]}
          mode="inline"
          defaultSelectedKeys={defaultSelectedKeys}
          defaultOpenKeys={defaultOpenKeys}
          items={menuData}
        />
        <div>
          {per?.caseSimulator && (
            <a
              href={caseSimulatorUrl}
              target="_blank"
              rel="noreferrer"
              style={{ color: themeToken.colorTextSecondary }}
            >
              <div className={styles.collapseBtn} style={{ color: themeToken.colorTextSecondary }}>
                <span
                  style={{ fontSize: 24, color: themeToken.colorTextTertiary }}
                  className={classNames('iconfont', styles.collapseBtnIcon)}
                />
                {!collapsed ? '病例模拟' : ''}
              </div>
            </a>
          )}
          <div
            className={styles.collapseBtn}
            style={{ color: themeToken.colorTextSecondary }}
            onClick={() => setCollapsed(!collapsed)}
          >
            <span
              style={{ fontSize: 24, color: themeToken.colorTextTertiary }}
              className={classNames(
                'iconfont',
                collapsed ? 'icon-sidebar-fold-line' : 'icon-sidebar-unfold-line',
              )}
            />
            {!collapsed ? '收起菜单' : ''}
          </div>
        </div>
      </Sider>
    );
  };

  // @ts-ignore
  return (
    <Layout className={styles.layout}>
      {renderHeader()}
      <Layout>
        {renderSider()}
        <Content className={styles.content}>
          <CacheBar onChange={setCacheHeight} />
          {/* <Navbar /> */}
          <Breadcrumb onChange={setBreadCrumbHeight} />
          <div
            className={styles.contentWrapper}
            style={
              {
                '--cacheHeight': `${cacheHeight}px`,
                '--breadCrumbHeight': `${breadCrumbHeight}px`,
              } as React.CSSProperties
            }
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Home;
